import type { LearningProblem } from './learningTypes';

export const requiresLearningMaze = (problem: LearningProblem) => (
  problem.requiredNodeKinds.includes('tof')
  || problem.goals.some(({ type }) => type === 'goalReached' || type === 'noCollision')
);